var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

export var DataAttribute = {
  ElementCodename: 'data-kontent-element-codename',
  ItemId: 'data-kontent-item-id',
  LanguageCodename: 'data-kontent-language-codename',
  ProjectId: 'data-kontent-project-id'
};
export function dataToDatasetAttributeName(dataAttributeName) {
  return dataAttributeName.replace(/^data-/, '').replace(/-./g, function (x) {
    return x.toUpperCase()[1];
  });
}
export function getDataAttributesFromEventPath(event) {
  var e_1, _a, e_2, _b;

  var path = event.composedPath();
  var parsed = new Map();

  try {
    for (var path_1 = __values(path), path_1_1 = path_1.next(); !path_1_1.done; path_1_1 = path_1.next()) {
      var node = path_1_1.value;
      if (!(node instanceof HTMLElement)) continue;

      try {
        for (var _c = (e_2 = void 0, __values(Object.entries(DataAttribute))), _d = _c.next(); !_d.done; _d = _c.next()) {
          var _e = __read(_d.value, 2),
              attrName = _e[1];

          var datasetAttrName = dataToDatasetAttributeName(attrName);
          var datasetAttr = node.dataset[datasetAttrName];

          if (datasetAttr && !parsed.has(attrName)) {
            parsed.set(attrName, datasetAttr);
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (path_1_1 && !path_1_1.done && (_a = path_1.return)) _a.call(path_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return parsed;
}